/* ============================================================
   FAD THEME v2 , theme.js
   Cart drawer, gallery, variants, sticky ATC, ticker, quantity
   ============================================================ */
(function(){
'use strict';

/* ---- SHOW/HIDE HELPERS (immune to CSS specificity conflicts) ---- */
function showEl(el){if(el){el.style.display='';el.removeAttribute('hidden');}}
function hideEl(el){if(el){el.style.display='none';el.setAttribute('hidden','');}}

/* ---- UTILS ---- */
function qs(s,c){return(c||document).querySelector(s);}
function qsa(s,c){return Array.from((c||document).querySelectorAll(s));}
function on(el,ev,fn){if(el)el.addEventListener(ev,fn);}
function formatMoney(cents){
  var fmt=(window.theme&&window.theme.moneyFormat)||'${{amount}}';
  cents=parseInt(cents,10)||0;
  var value=cents/100;
  function withSep(num,thousands,decimal,decimals){
    decimals=decimals==null?2:decimals;
    var parts=Math.abs(num).toFixed(decimals).split('.');
    parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,thousands);
    var out=parts.join(decimals>0?decimal:'');
    return num<0?'-'+out:out;
  }
  return fmt
    .replace(/\{\{\s*amount\s*\}\}/g,withSep(value,',','.',2))
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,withSep(value,',','.',0))
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,withSep(value,'.',',',2))
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,withSep(value,'.',',',0))
    .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g,withSep(value,' ',',',2))
    .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g,withSep(value,"'",'.',2))
    .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g,withSep(value,' ',',',0));
}

/* ---- HEADER MOBILE NAV ---- */
function initNav(){
  /* ── Mobile hamburger ─────────────────────── */
  var btn=qs('#menu-toggle');
  var nav=qs('#mobile-nav');
  if(btn&&nav){
    on(btn,'click',function(){
      var open=btn.classList.toggle('is-open');
      nav.classList.toggle('is-open',open);
      btn.setAttribute('aria-expanded',String(open));
      nav.setAttribute('aria-hidden',String(!open));
    });
  }

  /* ── Desktop dropdown: click-toggled ─────── */
  /* CSS-only hover breaks on sticky headers due to stacking context.
     Fix: toggle .is-open class on click, close on outside click / Escape. */
  var dropdownParents=qsa('.has-dropdown');
  dropdownParents.forEach(function(parent){
    var trigger=parent.querySelector('.header__nav-btn');
    if(!trigger)return;
    on(trigger,'click',function(e){
      e.stopPropagation();
      var isOpen=parent.classList.contains('is-open');
      /* close all others */
      dropdownParents.forEach(function(p){
        p.classList.remove('is-open');
        var t=p.querySelector('.header__nav-btn');
        if(t)t.setAttribute('aria-expanded','false');
      });
      if(!isOpen){
        parent.classList.add('is-open');
        trigger.setAttribute('aria-expanded','true');
      }
    });
  });

  /* Close dropdowns on outside click */
  document.addEventListener('click',function(){
    dropdownParents.forEach(function(p){
      p.classList.remove('is-open');
      var t=p.querySelector('.header__nav-btn');
      if(t)t.setAttribute('aria-expanded','false');
    });
  });

  /* Close on Escape */
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      dropdownParents.forEach(function(p){
        p.classList.remove('is-open');
        var t=p.querySelector('.header__nav-btn');
        if(t)t.setAttribute('aria-expanded','false');
      });
    }
  });

  /* ── Mobile accordion sub-menus ─────────── */
  qsa('.header__mobile-parent-btn').forEach(function(parentBtn){
    on(parentBtn,'click',function(){
      var sub=parentBtn.nextElementSibling;
      if(!sub)return;
      var isOpen=parentBtn.getAttribute('aria-expanded')==='true';
      parentBtn.setAttribute('aria-expanded',String(!isOpen));
      if(isOpen){hideEl(sub);}else{showEl(sub);}
    });
  });
}

/* ---- CART DRAWER ---- */
var drawerOpen=false;
function openDrawer(){
  var d=qs('#cart-drawer');
  if(!d)return;
  d.setAttribute('aria-hidden','false');
  drawerOpen=true;
  document.body.style.overflow='hidden';
  refreshDrawer();
}
function closeDrawer(){
  var d=qs('#cart-drawer');
  if(!d)return;
  d.setAttribute('aria-hidden','true');
  drawerOpen=false;
  document.body.style.overflow='';
}
function refreshDrawer(){
  fetch('/cart.js',{headers:{Accept:'application/json'}})
  .then(function(r){return r.json();})
  .then(function(cart){
    var bodyEl=qs('#cart-drawer-body');
    var emptyEl=qs('#cart-drawer-empty');
    var itemsEl=qs('#cart-drawer-items');
    var footerEl=qs('#cart-drawer-footer');
    var countEl=qs('#drawer-count');
    var subtotalEl=qs('#drawer-subtotal');
    if(countEl)countEl.textContent=cart.item_count>0?'('+cart.item_count+')':'';
    updateCartBadge(cart.item_count);
    if(cart.item_count===0){
      showEl(emptyEl);
      hideEl(itemsEl);
      hideEl(footerEl);
      return;
    }
    hideEl(emptyEl);
    showEl(itemsEl);
    showEl(footerEl);
    if(subtotalEl)subtotalEl.textContent=formatMoney(cart.total_price);
    // v4.30: free express shipping over $125, $9.99 below
    var THRESHOLD=12500;
    var msgEl=qs('#shipping-msg');
    var fillEl=qs('#shipping-fill');
    var remEl=qs('#shipping-remaining');
    if(msgEl&&fillEl){
      var pct=Math.min(100,Math.round((cart.total_price/THRESHOLD)*100));
      fillEl.style.width=pct+'%';
      if(cart.total_price>=THRESHOLD){
        msgEl.innerHTML='You qualify for <strong>free tracked express shipping</strong>';
        msgEl.classList.add('is-complete');
      } else {
        var rem=THRESHOLD-cart.total_price;
        msgEl.classList.remove('is-complete');
        msgEl.innerHTML='Add <strong id="shipping-remaining">'+formatMoney(rem)+'</strong> for free express. Otherwise $9.99 tracked.';
      }
    }
    var html='';
    cart.items.forEach(function(item,idx){
      html+='<div class="drawer-item" data-line="'+(idx+1)+'">';
      if(item.image)html+='<img src="'+item.image+'" alt="'+item.product_title+'" width="72" height="72" loading="lazy" class="drawer-item__img">';
      html+='<div class="drawer-item__info">';
      html+='<a href="'+item.url+'" class="drawer-item__title">'+item.product_title+'</a>';
      if(item.variant_title&&item.variant_title!=='Default Title')html+='<p class="drawer-item__variant">'+item.variant_title+'</p>';
      html+='<p class="drawer-item__price">'+formatMoney(item.final_line_price)+'</p>';
      html+='<div class="drawer-item__qty">';
      html+='<button class="drawer-qty-btn" data-action="dec" data-line="'+(idx+1)+'" aria-label="Decrease">-</button>';
      html+='<span class="drawer-qty-val">'+item.quantity+'</span>';
      html+='<button class="drawer-qty-btn" data-action="inc" data-line="'+(idx+1)+'" aria-label="Increase">+</button>';
      html+='</div></div>';
      html+='<button class="drawer-item__remove" data-line="'+(idx+1)+'" aria-label="Remove"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 3.5h10M5 3.5V2.5a.5.5 0 011 0v1m2 0V2.5a.5.5 0 011 0v1M3.5 3.5l1 8h5l1-8" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/></svg></button>';
      html+='</div>';
    });
    // v4.30: Core upsell tied to $125 free express shipping threshold
    var THRESHOLD2=12500;
    if(cart.total_price<THRESHOLD2 && cart.total_price>0){
      var rem=THRESHOLD2-cart.total_price;
      html+='<div class="drawer-upsell">'
        +'<div class="drawer-upsell__text">'
        +'<p class="drawer-upsell__headline">Add a Flavour Core to unlock <strong>free express shipping</strong></p>'
        +'<p class="drawer-upsell__sub">'+formatMoney(rem)+' away. Otherwise $9.99 tracked express.</p>'
        +'</div>'
        +'<a href="/collections/core-packs" class="drawer-upsell__btn">Browse Cores</a>'
        +'</div>';
    }
    if(itemsEl)itemsEl.innerHTML=html;
  });
}
function updateCartBadge(count){
  qsa('#cart-count').forEach(function(el){
    el.textContent=count||'';
    el.style.display=count>0?'flex':'none';
  });
}
function initCartDrawer(){
  on(qs('#cart-toggle'),'click',function(){drawerOpen?closeDrawer():openDrawer();});
  on(qs('#cart-drawer-close'),'click',closeDrawer);
  on(qs('#cart-overlay'),'click',closeDrawer);
  on(document,'keydown',function(e){if(e.key==='Escape'&&drawerOpen)closeDrawer();});
  on(document,'click',function(e){
    var btn=e.target.closest('.drawer-qty-btn');
    if(btn){
      var line=btn.getAttribute('data-line');
      var action=btn.getAttribute('data-action');
      var val=btn.closest('.drawer-item__qty').querySelector('.drawer-qty-val');
      var cur=parseInt(val?val.textContent:1,10);
      var newQty=action==='dec'?Math.max(0,cur-1):cur+1;
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:newQty})})
      .then(function(r){return r.json();}).then(function(){refreshDrawer();});
    }
    var rem=e.target.closest('.drawer-item__remove');
    if(rem){
      var l=rem.getAttribute('data-line');
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:l,quantity:0})})
      .then(function(r){return r.json();}).then(function(){refreshDrawer();});
    }
  });
}

/* ---- ADD TO CART ---- */
function doATC(variantId,qty,btn){
  if(!variantId)return;
  var origText=btn?btn.textContent:'';
  if(btn){btn.disabled=true;btn.textContent='Adding...';}
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({id:variantId,quantity:qty||1})
  })
  .then(function(r){return r.json();})
  .then(function(){
    if(btn){btn.disabled=false;btn.textContent=origText;}
    openDrawer();
  })
  .catch(function(){
    if(btn){btn.disabled=false;btn.textContent='Error - Try Again';}
  });
}

function initATC(){
  on(document,'click',function(e){
    var btn=e.target.closest('.atc-btn,.pcard__quick-add,.sticky-atc__btn');
    if(!btn||btn.disabled)return;
    e.preventDefault();
    var vid=btn.getAttribute('data-variant');
    var qty=1;
    var qtyInp=qs('#qty-input');
    if(qtyInp)qty=parseInt(qtyInp.value,10)||1;
    doATC(vid,qty,btn);
  });
}

/* ---- PRODUCT GALLERY ---- */
function initGallery(){
  /* Thumb handling moved to initGalleryArrows for unified goTo with dots and transitions */
}

/* ---- VARIANT SELECTOR ---- */
function initVariants(){
  var vs=qs('#variant-select');
  if(!vs)return;
  var priceEl=qs('#prod-price');
  var stockEl=qs('#prod-stock');
  var atcBtn=qs('#atc-btn');
  var stickyBtn=qs('#sticky-atc-btn');
  var stickyPrice=qs('#sticky-price');
  var buyNow=qs('#buy-now-btn');

  function getSelectedVals(){
    var vals={};
    qsa('.variant-group').forEach(function(g){
      var idx=g.getAttribute('data-opt-idx');
      var sel=g.querySelector('.vbtn.is-selected');
      if(sel)vals[idx]=sel.getAttribute('data-val');
    });
    return vals;
  }
  function findVariant(vals){
    var opts=Object.values(vals);
    var found=null;
    qsa('option',vs).forEach(function(o){
      var parts=o.textContent.trim().split(' / ');
      if(opts.every(function(v,i){return parts[i]===v;}))found=o;
    });
    return found;
  }
  function applyVariant(opt){
    if(!opt)return;
    var price=parseInt(opt.getAttribute('data-price'),10);
    var compare=parseInt(opt.getAttribute('data-compare'),10);
    var avail=opt.getAttribute('data-avail')==='true';
    var stock=parseInt(opt.getAttribute('data-stock'),10);
    var vid=opt.value;
    vs.value=vid;
    if(priceEl){
      var h='';
      if(compare&&compare>price){
        var save=compare-price;
        h='<span class="price price--sale">'+formatMoney(price)+'</span>';
        h+='<span class="price price--compare">'+formatMoney(compare)+'</span>';
        h+='<span class="price-save-pill">Save '+formatMoney(save)+'</span>';
      }else{h='<span class="price">'+formatMoney(price)+'</span>';}
      priceEl.innerHTML=h;
    }
    if(stockEl){
      var lowStock=parseInt(stockEl.getAttribute('data-low-stock')||'5',10);
      var sb='';
      if(!avail)sb='<span class="stock-badge stock-badge--out">Out of stock</span>';
      else if(stock<=lowStock&&stock>0)sb='<span class="stock-badge stock-badge--low"><svg width="8" height="8" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4" fill="#e07b39"/></svg>Only '+stock+' left</span>';
      else sb='<span class="stock-badge stock-badge--in"><svg width="8" height="8" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4" fill="#28a745"/></svg>In stock, ships today</span>';
      stockEl.innerHTML=sb;
    }
    if(atcBtn){atcBtn.disabled=!avail;atcBtn.setAttribute('data-variant',vid);atcBtn.textContent=avail?(atcBtn.getAttribute('data-orig-text')||'Add to Cart'):'Sold Out';}
    if(stickyBtn){stickyBtn.disabled=!avail;stickyBtn.setAttribute('data-variant',vid);}
    if(stickyPrice)stickyPrice.textContent=formatMoney(price);
    if(buyNow){buyNow.setAttribute('data-variant',vid);}
  }
  on(document,'click',function(e){
    var btn=e.target.closest('.vbtn');
    if(!btn)return;
    var group=btn.closest('.variant-group');
    if(!group)return;
    qsa('.vbtn',group).forEach(function(b){b.classList.remove('is-selected');});
    btn.classList.add('is-selected');
    var idx=group.getAttribute('data-opt-idx');
    var labelVal=qs('#opt-val-'+idx);
    if(labelVal)labelVal.textContent=btn.getAttribute('data-val');
    var variant=findVariant(getSelectedVals());
    applyVariant(variant);
    /* FIX: swap gallery to variant's featured image */
    var varImg=btn.getAttribute('data-img');
    if(varImg){
      var slides=qsa('.pgallery-slide');
      var thumbs2=qsa('.pgthumb');
      var matched=-1;
      slides.forEach(function(s,i){
        var img=s.querySelector('img');
        if(img&&img.src&&img.src.split('?')[0]===varImg.split('?')[0])matched=i;
      });
      if(matched>-1){
        slides.forEach(function(s,i){s.classList.toggle('is-active',i===matched);});
        thumbs2.forEach(function(t,i){t.classList.toggle('is-active',i===matched);});
        if(thumbs2[matched])thumbs2[matched].scrollIntoView({block:'nearest',behavior:'smooth'});
      }
    }
  });
}

/* ---- QUANTITY CONTROLS ---- */
function initQty(){
  var inp=qs('#qty-input');
  var hidden=qs('#qty-hidden');
  function syncAll(val){
    val=Math.max(1,Math.min(99,val));
    if(inp)inp.value=val;
    if(hidden)hidden.value=val;
    var vid=(qs('#variant-select')||qs('#variant-input')||{}).value;
    var buyNow=qs('#buy-now-btn');
    if(buyNow&&vid)buyNow.href='/checkout?variant='+vid+'&quantity='+val;
  }
  on(document,'click',function(e){
    var btn=e.target.closest('.qty-btn');
    if(!btn||!inp)return;
    var v=parseInt(inp.value,10)||1;
    syncAll(btn.getAttribute('data-dir')==='1'?v+1:v-1);
  });
  if(inp)on(inp,'change',function(){syncAll(parseInt(inp.value,10)||1);});
}

/* ---- STICKY ATC ---- */
function initStickyATC(){
  var bar=qs('#sticky-atc');
  var trigger=qs('#atc-btn');
  if(!bar||!trigger||typeof IntersectionObserver==='undefined')return;
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      bar.classList.toggle('is-visible',!entry.isIntersecting);
      bar.setAttribute('aria-hidden',String(entry.isIntersecting));
    });
  },{threshold:0});
  obs.observe(trigger);
  // Note: #sticky-atc-btn carries class "sticky-atc__btn", which initATC's
  // global delegated click handler already matches and adds to cart via
  // doATC(). Do not also dispatch a submit on #fad-product-form here ,
  // doing both was firing /cart/add.js twice per click (qty doubled).
}

/* ---- PRODUCT TABS ---- */
function initTabs(){
  var containers=document.querySelectorAll('.product-tabs');
  containers.forEach(function(container){
    var tabs=container.querySelectorAll('.product-tabs__tab');
    var panels=container.querySelectorAll('.product-tabs__panel');
    tabs.forEach(function(tab){
      on(tab,'click',function(){
        var targetId=tab.getAttribute('data-tab');
        tabs.forEach(function(t){t.classList.remove('is-active');t.setAttribute('aria-selected','false');});
        panels.forEach(function(p){p.classList.remove('is-active');hideEl(p);});
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected','true');
        var panel=document.getElementById('tab-panel-'+targetId)||container.querySelector('[data-panel="'+targetId+'"]');
        if(panel){panel.classList.add('is-active');showEl(panel);}
      });
    });
  });
}

/* ---- CART PAGE QTY ---- */
function initCartPageQty(){
  on(document,'click',function(e){
    var btn=e.target.closest('.cart-qty-btn');
    if(!btn)return;
    // Cart page has its own inline handler for #cart-page-items - avoid double-fire
    if(btn.closest('#cart-page-items'))return;
    var line=btn.getAttribute('data-line');
    var valEl=btn.closest('.cart-row__qty').querySelector('.cart-qty-val');
    var cur=parseInt(valEl?valEl.textContent:1,10);
    var newQty=btn.getAttribute('data-action')==='inc'?cur+1:Math.max(0,cur-1);
    if(valEl)valEl.textContent=newQty;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:newQty})})
    .then(function(r){return r.json();})
    .then(function(cart){
      updateCartBadge(cart.item_count);
      var sub=qs('#cart-sub-display');
      if(sub)sub.textContent=formatMoney(cart.total_price);
      if(newQty===0){var row=btn.closest('.cart-row');if(row)row.remove();}
      if(cart.item_count===0)location.reload();
    });
    var rem=e.target.closest('.cart-row__remove');
    if(rem&&rem.closest('#cart-page-items'))return; // handled by cart page inline script
    if(rem){
      var l=rem.getAttribute('data-line');
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:l,quantity:0})})
      .then(function(r){return r.json();})
      .then(function(cart){
        var row=rem.closest('.cart-row');if(row)row.remove();
        updateCartBadge(cart.item_count);
        if(cart.item_count===0)location.reload();
      });
    }
  });
}

/* ---- TICKER PAUSE ON HOVER ---- */
function initTicker(){
  var track=qs('.ticker-bar__track');
  if(!track)return;
  on(track,'mouseenter',function(){qsa('.ticker-bar__inner').forEach(function(el){el.style.animationPlayState='paused';});});
  on(track,'mouseleave',function(){qsa('.ticker-bar__inner').forEach(function(el){el.style.animationPlayState='running';});});
}

/* ---- INIT ---- */
document.addEventListener('DOMContentLoaded',function(){
  initNav();
  initCartDrawer();
  initATC();
  initGallery();
  initGalleryArrows();
  initVariants();
  initQty();
  initStickyATC();
  initTabs();
  initAccordion();
  initCartPageQty();
  initTicker();
  fetch('/cart.js',{headers:{Accept:'application/json'}})
  .then(function(r){return r.json();})
  .then(function(c){updateCartBadge(c.item_count);});
});

})();

/* ============================================================
   NAMED INIT FUNCTIONS
   All formerly-patched DOMContentLoaded blocks converted to
   named functions, called once from the single init handler.
   ============================================================ */

/* ── initGalleryArrows , prev/next, dots, touch swipe, keyboard ── */
function initGalleryArrows(){
  var gallery=document.getElementById('pgallery');
  var mainEl=document.getElementById('pgallery-main');
  if(!gallery||!mainEl)return;
  var slides=Array.from(gallery.querySelectorAll('.pgallery-slide'));
  var thumbs=Array.from(gallery.querySelectorAll('.pgthumb'));
  var total=slides.length;
  if(total<=1){gallery.classList.add('product-gallery--one');return;}

  var current=0;
  slides.forEach(function(s,i){if(s.classList.contains('is-active'))current=i;});

  // ── Build prev/next buttons ───────────────────────────────────
  function makeBtn(dir){
    var btn=document.createElement('button');
    btn.type='button';
    btn.className='pgallery-arrow pgallery-arrow--'+dir;
    btn.setAttribute('aria-label',dir==='prev'?'Previous image':'Next image');
    btn.innerHTML=dir==='prev'
      ?'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>'
      :'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
    return btn;
  }
  var prevBtn=makeBtn('prev');
  var nextBtn=makeBtn('next');

  // ── Build dot indicators ──────────────────────────────────────
  var dotsWrap=document.createElement('div');
  dotsWrap.className='pgallery-dots';
  var dots=[];
  for(var d=0;d<total;d++){
    var dot=document.createElement('button');
    dot.type='button';
    dot.className='pgallery-dot'+(d===0?' is-active':'');
    dot.setAttribute('aria-label','Image '+(d+1)+' of '+total);
    dot.setAttribute('data-idx',String(d));
    dotsWrap.appendChild(dot);
    dots.push(dot);
  }

  // ── Build overlay arrows inside the main image ──────────────
  prevBtn.classList.add('pgallery-arrow--overlay','pgallery-arrow--overlay-prev');
  nextBtn.classList.add('pgallery-arrow--overlay','pgallery-arrow--overlay-next');
  mainEl.style.position='relative';
  mainEl.appendChild(prevBtn);
  mainEl.appendChild(nextBtn);

  // ── Build dots-only bar below image ──────────────────────────
  var ctrl=document.createElement('div');
  ctrl.className='pgallery-ctrl pgallery-ctrl--dots-only';
  ctrl.setAttribute('aria-hidden','true');
  ctrl.appendChild(dotsWrap);
  gallery.appendChild(ctrl);

  // ── Core goTo ─────────────────────────────────────────────────
  var track=document.getElementById('pgallery-track');
  function centerThumb(idx){
    if(!track||!thumbs[idx])return;
    // Translate the track so active thumb is centered in the filmstrip container
    var filmstrip=track.parentElement;
    var stripW=filmstrip.offsetWidth;
    var thumb=thumbs[idx];
    var thumbW=thumb.offsetWidth;
    var thumbGap=10;
    var totalThumbW=thumbW+thumbGap;
    // track has width:100% so track.scrollWidth === stripW even when the
    // thumbnails themselves take up less space , compute real content
    // width directly from the thumbnails instead.
    var contentW=(thumbs.length*thumbW)+((thumbs.length-1)*thumbGap);
    if(contentW<=stripW){
      // All thumbnails fit , centre the whole row evenly on both sides.
      var pad=(stripW-contentW)/2;
      track.style.transform='translateX('+pad+'px)';
      return;
    }
    var offset=(idx*totalThumbW)-(stripW/2)+(thumbW/2);
    offset=Math.max(0,Math.min(offset,contentW-stripW));
    track.style.transform='translateX(-'+offset+'px)';
  }
  function goTo(idx){
    idx=((idx%total)+total)%total;
    slides[current].classList.remove('is-active');
    if(thumbs[current])thumbs[current].classList.remove('is-active');
    if(dots[current])dots[current].classList.remove('is-active');
    current=idx;
    slides[current].classList.add('is-active');
    if(thumbs[current])thumbs[current].classList.add('is-active');
    if(dots[current])dots[current].classList.add('is-active');
    centerThumb(idx);
  }

  // Wire up overlay arrow buttons
  prevBtn.addEventListener('click',function(e){e.stopPropagation();goTo(current-1);});
  nextBtn.addEventListener('click',function(e){e.stopPropagation();goTo(current+1);});

  // Dot clicks
  dots.forEach(function(dot){
    dot.addEventListener('click',function(){goTo(parseInt(dot.getAttribute('data-idx'),10));});
  });

  // ── Thumbnail clicks ───────────────────────────────────────────
  thumbs.forEach(function(t,i){t.addEventListener('click',function(){goTo(i);});});

  // ── Keyboard nav ──────────────────────────────────────────────
  document.addEventListener('keydown',function(e){
    if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')return;
    var r=mainEl.getBoundingClientRect();
    if(r.bottom<0||r.top>window.innerHeight)return;
    e.preventDefault();
    goTo(e.key==='ArrowLeft'?current-1:current+1);
  });

  // ── Touch swipe with momentum feel ───────────────────────────
  var tx=0,ty=0,swiping=false;
  mainEl.addEventListener('touchstart',function(e){
    tx=e.touches[0].clientX;
    ty=e.touches[0].clientY;
    swiping=true;
  },{passive:true});
  mainEl.addEventListener('touchmove',function(e){
    if(!swiping)return;
    var dx=e.touches[0].clientX-tx;
    var dy=e.touches[0].clientY-ty;
    // Block vertical scroll hijack only when clearly horizontal
    if(Math.abs(dx)>Math.abs(dy)+8){e.preventDefault();}
  },{passive:false});
  mainEl.addEventListener('touchend',function(e){
    if(!swiping)return;
    swiping=false;
    var dx=tx-e.changedTouches[0].clientX;
    var dy=ty-e.changedTouches[0].clientY;
    if(Math.abs(dx)>32&&Math.abs(dx)>Math.abs(dy)){goTo(dx>0?current+1:current-1);}
  },{passive:true});

  // Centre the filmstrip on initial load (covers the "few thumbnails,
  // left-aligned instead of centred" case before any interaction).
  requestAnimationFrame(function(){centerThumb(current);});
  window.addEventListener('resize',function(){centerThumb(current);});
}

/* ── #atc-btn add-to-cart handled by initATC/doATC (single path) ── */

/* ── initAccordion , animated product accordion, aria, keyboard ── */
function initAccordion(){
  var acc=document.getElementById('product-accordion');
  if(!acc)return;
  var items=Array.from(acc.querySelectorAll('.pacc__item'));
  items.forEach(function(item){
    var body=item.querySelector('.pacc__body');
    if(!body)return;
    if(item.classList.contains('is-open')){
      body.removeAttribute('hidden');
      requestAnimationFrame(function(){
        body.style.maxHeight=body.scrollHeight+'px';
        body.style.visibility='visible';
      });
    }else{
      body.setAttribute('hidden','');
      body.style.maxHeight='0';
      body.style.visibility='hidden';
    }
  });
  function openItem(item){
    var body=item.querySelector('.pacc__body');
    var btn=item.querySelector('.pacc__trigger');
    if(!body||!btn)return;
    item.classList.add('is-open');
    btn.setAttribute('aria-expanded','true');
    body.removeAttribute('hidden');
    body.style.visibility='visible';
    requestAnimationFrame(function(){body.style.maxHeight=body.scrollHeight+'px';});
  }
  function closeItem(item){
    var body=item.querySelector('.pacc__body');
    var btn=item.querySelector('.pacc__trigger');
    if(!body||!btn)return;
    item.classList.remove('is-open');
    btn.setAttribute('aria-expanded','false');
    body.style.maxHeight='0';
    body.addEventListener('transitionend',function hide(){
      body.removeEventListener('transitionend',hide);
      if(!item.classList.contains('is-open')){
        body.setAttribute('hidden','');
        body.style.visibility='hidden';
      }
    });
  }
  items.forEach(function(item){
    var btn=item.querySelector('.pacc__trigger');
    if(!btn)return;
    btn.addEventListener('click',function(){
      /* Lock trigger in viewport: capture position before changes, restore after */
      var _btnTop=btn.getBoundingClientRect().top;
      if(item.classList.contains('is-open')){
        closeItem(item);
      }else{
        items.forEach(function(other){
          if(other!==item&&other.classList.contains('is-open'))closeItem(other);
        });
        openItem(item);
      }
      requestAnimationFrame(function(){
        var delta=btn.getBoundingClientRect().top-_btnTop;
        if(Math.abs(delta)>2)window.scrollBy({top:delta,behavior:'instant'});
      });
    });
    btn.addEventListener('keydown',function(e){
      var triggers=items.map(function(i){return i.querySelector('.pacc__trigger');}).filter(Boolean);
      var idx=triggers.indexOf(btn);
      if(e.key==='ArrowDown'){e.preventDefault();(triggers[idx+1]||triggers[0]).focus();}
      else if(e.key==='ArrowUp'){e.preventDefault();(triggers[idx-1]||triggers[triggers.length-1]).focus();}
      else if(e.key==='Home'){e.preventDefault();triggers[0].focus();}
      else if(e.key==='End'){e.preventDefault();triggers[triggers.length-1].focus();}
    });
  });
}

/* ── Collection card tilt + shimmer effect (core-packs & full-collection) ── */
(function () {
  var handles = ['core-packs', 'full-collection'];
  handles.forEach(function(handle) {
  var section = document.querySelector('[data-collection="' + handle + '"]');
  if (!section) return;

  var isTouch = 'ontouchstart' in window;

  function pct(v, size) { return Math.max(0, Math.min(100, (v / size) * 100)).toFixed(1) + '%'; }

  /* Spawn a CSS ripple ring at touch point */
  function spawnRipple(media, cx, cy) {
    var ring = document.createElement('span');
    ring.className = 'cpcard-ring';
    ring.style.cssText = 'position:absolute;pointer-events:none;z-index:6;border-radius:50%;'
      + 'left:' + cx + '%;top:' + cy + '%;transform:translate(-50%,-50%) scale(0);'
      + 'width:120%;padding-bottom:120%;'
      + 'border:1.5px solid rgba(200,169,110,0.7);'
      + 'animation:cpring 0.65s cubic-bezier(0.23,1,0.32,1) forwards;';
    media.appendChild(ring);
    setTimeout(function () { ring.remove(); }, 700);
  }

  /* Inject ring keyframe once */
  if (!document.getElementById('cpring-kf')) {
    var s = document.createElement('style');
    s.id = 'cpring-kf';
    s.textContent = '@keyframes cpring{0%{transform:translate(-50%,-50%) scale(0);opacity:0.9}100%{transform:translate(-50%,-50%) scale(1);opacity:0}}';
    document.head.appendChild(s);
  }

  section.querySelectorAll('.pcard').forEach(function (card) {
    var media = card.querySelector('.pcard__media');
    if (!media) return;

    if (!isTouch) {
      /* ── Desktop: shimmer follows mouse, image zooms — no tilt
         (tilt on media container breaks overflow clip → hard edges) */
      card.addEventListener('mousemove', function (e) {
        var r = media.getBoundingClientRect();
        media.style.setProperty('--cx', pct(e.clientX - r.left, r.width));
        media.style.setProperty('--cy', pct(e.clientY - r.top, r.height));
        card.classList.add('is-active');
      });
      card.addEventListener('mouseleave', function () {
        card.classList.remove('is-active');
      });

    } else {
      /* ── Mobile: spring-bounce + gold ring ripple ─────────── */
      card.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        var r = media.getBoundingClientRect();
        var cx = ((t.clientX - r.left) / r.width * 100).toFixed(1);
        var cy = ((t.clientY - r.top) / r.height * 100).toFixed(1);
        media.style.setProperty('--cx', cx + '%');
        media.style.setProperty('--cy', cy + '%');
        card.classList.add('is-active');
        spawnRipple(media, cx, cy);
        clearTimeout(card._ct);
        card._ct = setTimeout(function () {
          card.classList.remove('is-active');
        }, 800);
      }, { passive: true });
    }
  }); // end querySelectorAll forEach
  }); // end forEach handle
})();